import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: null,
  location: {},
  completeAddress: null,
  addresses: [], // Array to store address objects with lat, lng, line1, and line2
  selectAddress: {},
};

const slice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload;
    },

    setLocation(state, action) {
      console.log('payload', action.payload);
      state.location = action.payload;
    },

    setCompleteAddress(state, action) {
      state.completeAddress = action.payload;
    },

  
  },
});

export default slice.reducer;
const actions = slice.actions;

// Action creators
export const addLocation = data => async dispatch => {
  console.log('payload on slice ',data)
  dispatch(actions.setLocation(data));
};

export const setCompleteAddress = data => async dispatch => {
  dispatch(actions.setCompleteAddress(data));
};

